import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "../helpers/JsonMapper";
import PermissionCollection from "../permission/PermissionCollection";
import TutorialCollection from "../tutorial/TutorialCollection";
import JsonPermissionCollection from "../permission/JsonPermissionCollection";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Role extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Role.id_attribute_name]: null,
      [Role.name_attribute_name]: null,
      [Role.permissions_attribute_name]: PermissionCollection,
      [Role.tutorials_attribute_name]: TutorialCollection,
      [Role.default_permissions_attribute_name]: []
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getIdAttributeName() {
    return this.id_attribute_name;
  }
  static getNameAttributeName() {
    return this.name_attribute_name;
  }
  getId() {
    return this.getAttribute(Role.id_attribute_name);
  }
  getRoleName() {
    return this.getAttribute(Role.name_attribute_name);
  }
  getName() {
    return this.getAttribute(Role.name_attribute_name);
  }
  getTutorials() {
    return this.getAttribute(Role.tutorials_attribute_name);
  }
  isWarehouse() {
    return this.getName() === Role.WAREHOUSE_ROLE;
  }
  isAffiliate() {
    return this.getName() === Role.SELLER_ROLE;
  }
  isSeller() {
    return this.getName() === Role.SELLER_ROLE;
  }
  getDefaultPermissions() {
    return this.getAttribute(Role.default_permissions_attribute_name);
  }
  static getManagerRoles() {
    return [Role.ADMIN_ROLE, Role.MANAGER_ROLE];
  }
  static getSellerRoles() {
    return [Role.SELLER_ROLE, Role.INFLUENCER_ROLE];
  }
  static getWarehouseRoles() {
    return [Role.WAREHOUSE_ROLE, Role.CALL_AGENT_ROLE, Role.ADVERTISER_ROLE];
  }
  static getManagerAndSellerRoles() {
    return [...Role.getManagerRoles(), ...Role.getSellerRoles()];
  }
  static getManagerAndWarehouseRoles() {
    return [...Role.getManagerRoles(), ...Role.getWarehouseRoles()];
  }
  static getAllRoles() {
    return [Role.WAREHOUSE_ROLE, Role.CALL_AGENT_ROLE, Role.ADVERTISER_ROLE, Role.SELLER_ROLE, Role.INFLUENCER_ROLE, Role.ADMIN_ROLE, Role.MANAGER_ROLE];
  }
}
_defineProperty(Role, "ADMIN_ROLE", 'admin');
_defineProperty(Role, "MANAGER_ROLE", 'manager');
_defineProperty(Role, "ADVERTISER_ROLE", 'advertiser');
_defineProperty(Role, "SELLER_ROLE", 'seller');
_defineProperty(Role, "AFFILIATE_ROLE", 'affiliate');
_defineProperty(Role, "INFLUENCER_ROLE", 'influencer');
_defineProperty(Role, "CALL_AGENT_ROLE", 'call-agent');
_defineProperty(Role, "WAREHOUSE_ROLE", 'warehouse');
_defineProperty(Role, "id_attribute_name", 'role_id');
_defineProperty(Role, "name_attribute_name", 'role_name');
_defineProperty(Role, "permissions_attribute_name", 'role_permissions');
_defineProperty(Role, "tutorials_attribute_name", 'role_tutorials');
_defineProperty(Role, "default_permissions_attribute_name", 'default_permissions');